let lastId = 0;

export function generateId() {
    return --lastId;
}
